import React from "react";
import "./brandbanner.scss";
import { useTheme } from "../../../contexts/ThemeProvider";
import { LIGHT_THEME } from '../../../utils/constants';

const BrandBanner = () => {
  const { theme } = useTheme();
  return (
    <>
      <section className="brandbanner_bg">
        <img
          src="\assets\homepage\banner\banner-shadow.png"
          alt="img"
          className="img-fluid banner-shadow"
        />
        <video
          className="main-banner-video"
          muted="muted"
          playsinline="playsinline"
          autoPlay
          loop
          width="100%"
          id="myVideo"
        >
          <source src="\assets\bannervideo.mp4" type="video/mp4" />
        </video>
        <div className="custom-container brandbanner">
          <div className="twice-text">
            <h3 className="brandbanner__heading">Brand Assets</h3>
            <p className="brandbanner__para">
              Promoting RAIN through any digital or printed materials must adhere
              to the following guidelines.
            </p>
          </div>
          <a href="\assets\brandassets\rain-brand-assets.zip" className="brand__button" download>Download Brand Kit</a>
        </div>

      </section>
    </>
  );
};

export default BrandBanner;
